
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";

const EditTour = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [tourData, setTourData] = useState({
        location: "",
        state: "",
        description: "",
        imageUrl: "",
        date: "",
        inclusions: "",
        itinerary: "",
    });

    const fetchTour = async () => {
        try {
            const docRef = doc(fireDB, "tours", id);
            const tourSnap = await getDoc(docRef);
            if (tourSnap.exists()) {
                const data = tourSnap.data();
                setTourData({
                    ...data,
                    inclusions: Array.isArray(data.inclusions) ? data.inclusions.join(", ") : data.inclusions || "",
                });
            } else {
                alert("Tour not found!");
                navigate("/admin/add-tour");
            }
        } catch (err) {
            console.error("Error fetching tour:", err);
        }
    };

    const handleChange = (e) => {
        setTourData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleUpdate = async (e) => {
        e.preventDefault();

        if (!tourData.location || !tourData.description) {
            alert("Please fill in required fields.");
            return;
        }

        try {
            await updateDoc(doc(fireDB, "tours", id), {
                ...tourData,
                inclusions: tourData.inclusions.split(",").map((item) => item.trim()),
            });
            alert("✅ Tour updated successfully!");
            navigate("/admin/add-tour");
        } catch (err) {
            console.error("Error updating tour:", err);
            alert("❌ Failed to update tour.");
        }
    };

    useEffect(() => {
        fetchTour();
    }, [id]);

    return (
        <section className="py-5">
            <Container>
                <Row>
                    <Col md={8} className="mx-auto">
                        <Card className="p-4 shadow border-0">
                            <h3 className="mb-4 text-center">Edit Tour</h3>
                            <Form onSubmit={handleUpdate}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tour Location</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="location"
                                        value={tourData.location}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>State</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="state"
                                        value={tourData.state}
                                        onChange={handleChange}
                                        required
                                        placeholder="e.g. Gujarat, Rajasthan, Goa"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={4}
                                        name="description"
                                        value={tourData.description}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Tour Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="date"
                                        value={tourData.date}
                                        onChange={handleChange}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Image URL</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="imageUrl"
                                        value={tourData.imageUrl}
                                        onChange={handleChange}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Inclusions (comma-separated)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="inclusions"
                                        value={tourData.inclusions}
                                        onChange={handleChange}
                                        placeholder="e.g. Hotel, Guide, Transport, Meals"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Form.Label>Itinerary</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        name="itinerary"
                                        value={tourData.itinerary}
                                        onChange={handleChange}
                                        placeholder="e.g. Day 1: Arrival, Day 2: Sightseeing..."
                                    />
                                </Form.Group>

                                <div className="d-grid">
                                    <Button type="submit" className="primaryBtn btn-lg">
                                        Update Tour
                                    </Button>
                                </div>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default EditTour;
